import { render, staticRenderFns } from "./Distribuicao.vue?vue&type=template&id=367d2658&"
import script from "./Distribuicao.vue?vue&type=script&lang=js&"
export * from "./Distribuicao.vue?vue&type=script&lang=js&"
import style0 from "./Distribuicao.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports